import { trans } from '@spotahome/soyuz/client';

import {
  MobileBlueIcon,
  MedalIcon,
  KeyIcon,
  CameraIcon as CameraIconVariant
} from '@spotahome/ui-library';

import FeatureBoxList from './FeatureBoxList';

import './FeatureBoxSection.scss';

const FeatureBoxSection = () => {
  const featureList = [
    {
      icon: <MobileBlueIcon />,
      description: 'home.tenant.feature-box-section-first-item'
    },
    {
      icon: <MedalIcon />,
      description: 'home.tenant.feature-box-section-second-item'
    },
    {
      icon: <CameraIconVariant />,
      description: 'home.tenant.feature-box-section-third-item'
    },
    {
      icon: <KeyIcon />,
      description: 'home.tenant.feature-box-section-fourth-item'
    }
  ];
  return (
    <section className="feature-box-section">
      <h2 className="feature-box-title">
        {trans('home.tenant.feature-box-section-title')}
      </h2>
      <FeatureBoxList featureList={featureList} />
    </section>
  );
};

export default FeatureBoxSection;
